export default __webpack_public_path__ + "static/media/bg-header-01.32b9dc4f.png";